export default __webpack_public_path__ + "static/char-s-48-zh-Hans-5c7042bb947a896f34c8bf0b85a12d62.webp";